export default __webpack_public_path__ + "images/c98d75320ceb59309e151f3a6731fcf9.jpg";